<script lang="ts">
import VButton from "@/lib/components/VButton/VButton.vue";
import VButtonGroup from "@/lib/components/VButtonGroup/VButtonGroup.vue";
import VIcon   from "@/lib/components/VIcon/VIcon.vue";

export default defineComponent({
	name: "ButtonsSample",

	components: {
		VIcon,
		VButton,
		VButtonGroup
	},
});
</script>

<template>
	<article class="break">
		<VButton> Default </VButton>
		<VButton>
			<template v-slot:icon><VIcon material="cancel" /></template>
			Default
		</VButton>
		<VButton icon-postfix>
			<template v-slot:icon><VIcon material="cancel" /></template>
			Default
		</VButton>
		<VButton disabled> Default disabled </VButton>
	</article>

	<article class="break">
		<VButton theme="primary"> Primary </VButton>
		<VButton theme="primary">
			<template v-slot:icon><VIcon material="cancel" /></template>
			Primary
		</VButton>
		<VButton theme="primary" icon-postfix>
			<template v-slot:icon><VIcon material="cancel" /></template>
			Primary
		</VButton>
		<VButton theme="primary" disabled> Primary disabled </VButton>
	</article>

	<article class="break">
		<VButton theme="danger"> Danger </VButton>
		<VButton theme="danger">
			<template v-slot:icon><VIcon material="cancel" /></template>
			Danger
		</VButton>
		<VButton theme="danger" icon-postfix>
			<template v-slot:icon><VIcon material="cancel" /></template>
			Danger
		</VButton>
		<VButton theme="danger" disabled> Danger disabled </VButton>
	</article>

	<article class="break">
		<VButton theme="flat"> Flat </VButton>
		<VButton theme="flat">
			<template v-slot:icon><VIcon material="cancel" /></template>
			Flat
		</VButton>
		<VButton theme="flat" icon-postfix>
			<template v-slot:icon><VIcon material="cancel" /></template>
			Flat
		</VButton>
		<VButton theme="flat" disabled> Flat disabled </VButton>
	</article>

	<article class="break">
		<VButton theme="link"> Link </VButton>
		<VButton theme="link">
			<template v-slot:icon><VIcon material="cancel" /></template>
			Link
		</VButton>
		<VButton theme="link" icon-postfix>
			<template v-slot:icon><VIcon material="cancel" /></template>
			Link
		</VButton>
		<VButton theme="link" disabled> Link disabled </VButton>
	</article>

	<article class="break">
		<VButton>
			<template v-slot:icon><VIcon material="settings" /></template>
		</VButton>
		<VButton theme="primary">
			<template v-slot:icon><VIcon material="settings" /></template>
		</VButton>
		<VButton theme="flat">
			<template v-slot:icon><VIcon material="settings" /></template>
		</VButton>
		<VButton theme="link">
			<template v-slot:icon><VIcon material="settings" /></template>
		</VButton>
	</article>

	<article class="break">
		<VButtonGroup>
			<VButton theme="primary">
				<slot name="label-all">
					Мои потребности
				</slot>
			</VButton>
			<VButton
				theme="default"
			>
				<slot name="label-all">
					Все потребности
				</slot>
			</VButton>
		</VButtonGroup>
	</article>
</template>

<style scoped lang="scss">
.break {
	margin: 12px 0;
}
</style>
